'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002epages$002esign$002e$002dSign$002dView$0024$0024anon$002418 from "./presto.pages.sign.-Sign-View$$anon$18.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_sign_SignView$$anon$17(outer) {
  this.bWk = null;
  this.bWi = null;
  this.bWj = false;
  this.bWg = null;
  this.bWh = false;
  this.bWl = false;
  this.bWm = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bWk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_sign_SignView$$anon$17 as $c_Lpresto_pages_sign_SignView$$anon$17 };
$p = $c_Lpresto_pages_sign_SignView$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_sign_SignView$$anon$17;
/** @constructor */
function $h_Lpresto_pages_sign_SignView$$anon$17() {
}
export { $h_Lpresto_pages_sign_SignView$$anon$17 as $h_Lpresto_pages_sign_SignView$$anon$17 };
$h_Lpresto_pages_sign_SignView$$anon$17.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bWk;
});
$p.t = (function() {
  if ((!this.bWj)) {
    this.bWi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bWj = true;
  }
  return this.bWi;
});
$p.ae = (function() {
  if ((!this.bWh)) {
    this.bWg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002epages$002esign$002e$002dSign$002dView$0024$0024anon$002418.$c_Lpresto_pages_sign_SignView$$anon$18()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bWh = true;
  }
  return this.bWg;
});
$p.w = (function() {
  if ((!this.bWm)) {
    this.bWl = false;
    this.bWm = true;
  }
  return this.bWl;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_sign_SignView$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_sign_SignView$$anon$17, "presto.pages.sign.SignView$$anon$17", ({
  X1: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_sign_SignView$$anon$17 as $d_Lpresto_pages_sign_SignView$$anon$17 };
//# sourceMappingURL=presto.pages.sign.-Sign-View$$anon$17.js.map
